exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-button[data-v-7fb4b5c4]{font-size:2vw;margin-top:1vw}.modal-footer[data-v-7fb4b5c4]{display:none!important}", ""]);

// exports
